import { render, staticRenderFns } from "./AIAgent.MessageAttachments.vue?vue&type=template&id=19141012&lang=pug"
import script from "./AIAgent.MessageAttachments.vue?vue&type=script&lang=js"
export * from "./AIAgent.MessageAttachments.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.MessageAttachments.vue?vue&type=style&index=0&id=19141012&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports